import React, { useState } from 'react'
import { Copy, Check } from 'lucide-react'
import { WhatsappShareButton, WhatsappIcon } from 'react-share'
import { trackEvent } from '../../utils/analytics'


type ReferralBlockProps = {
  token: string
}

const ReferralBlock: React.FC<ReferralBlockProps> = ({ token }) => {
  const [copied, setCopied] = useState(false)
  const url = `${window.location.origin}/reviews/new?share_id=${token}`
  const title = "Donne ton avis sur ta voiture et tente de gagner 500€ de cadeau !"

  const handleCopy = async () => {
    await navigator.clipboard.writeText(url)
    setCopied(true)
    trackEvent({ name: 'referral_share', params: { token } })
    setTimeout(() => setCopied(false), 2000)
  }

  return (
    <div className="mt-6 rounded-2xl border border-violet-100 bg-gradient-to-br from-violet-50 to-indigo-50 p-6">
      <h3 className="text-base font-semibold text-gray-900">
        Envie de multiplier vos chances de gagner ?
      </h3>
      <p className="mt-1 text-sm text-gray-500">
        Partagez votre lien unique avec vos amis, votre famille, vos collègues… Chaque avis laissé via votre lien{' '}
        <span className="font-semibold" style={{ color: '#412FB2' }}>= 1 chance supplémentaire pour vous !</span>
      </p>
      <div className="mt-4 flex items-center gap-3">
        <button
          onClick={handleCopy}
          className="inline-flex items-center gap-2 rounded-lg px-4 py-2 text-sm font-medium text-white transition-opacity hover:opacity-90 active:scale-95"
          style={{ backgroundColor: '#412FB2' }}
        >
          {copied ? <Check size={16} /> : <Copy size={16} />}
          {copied ? 'Copié !' : 'Copier le lien'}
        </button>
        <WhatsappShareButton url={url} title={title}>
          <WhatsappIcon size={32} round />
        </WhatsappShareButton>
        <a
          href={`sms:?body=${encodeURIComponent(`${title} ${url}`)}`}
          style={{ display: 'inline-flex', width: 32, height: 32, borderRadius: '50%', backgroundColor: '#4CAF50', alignItems: 'center', justifyContent: 'center' }}
        >
          <svg viewBox="0 0 24 24" width="16" height="16" fill="white"><path d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2z"/></svg>
        </a>
      </div>
    </div>
  )
}

export default ReferralBlock
